import { Link } from 'react-router-dom';
import Aurora from '../home/components/Aurora';
import { CursorGlow } from '../home/components/CursorGlow';

export default function ServicesPage() {
  const services = [
    {
      icon: 'ri-code-box-line',
      title: 'SOFTWARE DEVELOPMENT & DIGITAL SOLUTIONS',
      description: 'Custom software development, web and mobile applications, enterprise systems, and digital transformation solutions tailored to your business needs.',
      features: ['Custom Web Applications', 'Mobile App Development', 'Enterprise Software', 'API Integration', 'Cloud Solutions']
    },
    {
      icon: 'ri-robot-2-line',
      title: 'AI AUTOMATED SYSTEMS FOR LARGE SCALE BUSINESSES',
      description: 'Cutting-edge AI automation solutions designed to streamline operations, enhance efficiency, and drive innovation for large-scale enterprises.',
      features: ['Process Automation', 'Machine Learning Integration', 'Predictive Analytics', 'Intelligent Chatbots', 'Data Processing']
    },
    {
      icon: 'ri-megaphone-line',
      title: 'MARKETING & MEDIA SOLUTIONS',
      description: 'Comprehensive marketing strategies, digital campaigns, media production, and content creation to amplify your brand presence.',
      features: ['Digital Marketing', 'Social Media Management', 'Content Strategy', 'Media Production', 'Brand Campaigns']
    },
    {
      icon: 'ri-palette-line',
      title: 'CREATIVE DESIGN & BRANDING',
      description: 'Professional branding, graphic design, motion graphics, and visual identity solutions that make your brand stand out.',
      features: ['Brand Identity Design', 'Logo & Visual Assets', 'Motion Graphics', 'UI/UX Design', 'Print & Digital Design']
    },
    {
      icon: 'ri-smartphone-line',
      title: 'HIGH-TECH GADGET IMPORTATION & DISTRIBUTION',
      description: 'Supply and distribution of cutting-edge technology equipment and gadgets for businesses, organizations, and government institutions.',
      features: ['Tech Equipment Supply', 'Enterprise Hardware', 'Smart Devices', 'IT Infrastructure', 'Logistics & Distribution']
    }
  ];

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Aurora Background */}
      <div className="fixed inset-0 z-0">
        <Aurora 
          colorStops={['#ed66ff', '#b19eef', '#5227ff']}
          amplitude={1.2}
          blend={0.6}
          speed={0.8}
        />
      </div>

      {/* Global Effects */}
      <CursorGlow />

      {/* Content */}
      <div className="relative z-10">
        <div className="absolute inset-0 bg-black/30"></div>
        
        <div className="relative z-10 pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-20 md:pb-24">
          <div className="container mx-auto px-4 sm:px-6">
            {/* Header */}
            <div className="text-center mb-12 sm:mb-16 md:mb-20">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.1em] px-4">
                OUR <span className="bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">SERVICES</span>
              </h1>
              <p className="text-gray-400 text-base sm:text-lg md:text-xl max-w-3xl mx-auto font-light leading-relaxed px-4">
                Comprehensive solutions that combine creativity with technology to drive your business forward
              </p>
            </div>

            {/* Services Grid */}
            <div className="space-y-8 sm:space-y-10 md:space-y-12 max-w-6xl mx-auto">
              {services.map((service, index) => (
                <div 
                  key={index}
                  className="group bg-black/40 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 sm:p-8 hover:border-purple-500/50 transition-all duration-500 hover:shadow-2xl hover:shadow-purple-500/10"
                >
                  <div className="flex flex-col md:flex-row gap-6 sm:gap-8">
                    {/* Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-violet-500/20 to-purple-500/20 rounded-2xl border border-purple-500/30 group-hover:scale-110 transition-transform duration-500">
                        <i className={`${service.icon} text-3xl sm:text-4xl text-purple-400`}></i>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                      <h3 className="text-xl sm:text-2xl font-light text-white mb-3 sm:mb-4 tracking-wide">
                        {service.title}
                      </h3>
                      <p className="text-gray-400 text-sm sm:text-base leading-relaxed mb-5 sm:mb-6">
                        {service.description}
                      </p>

                      {/* Features */}
                      <div className="flex flex-wrap gap-2 sm:gap-3">
                        {service.features.map((feature, idx) => (
                          <span 
                            key={idx}
                            className="px-3 sm:px-4 py-1.5 sm:py-2 bg-purple-500/10 border border-purple-500/30 rounded-lg text-xs sm:text-sm text-purple-300 hover:bg-purple-500/20 transition-colors duration-300"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Section */}
            <div className="mt-12 sm:mt-16 md:mt-20 text-center">
              <div className="bg-gradient-to-r from-violet-500/10 to-purple-500/10 border border-purple-500/30 rounded-2xl p-8 sm:p-10 md:p-12 max-w-4xl mx-auto">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-white mb-4 sm:mb-6 tracking-wide">
                  Ready to Transform Your Business?
                </h2>
                <p className="text-gray-400 text-base sm:text-lg mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
                  Let's discuss how our services can help you achieve your goals and drive sustainable growth
                </p>
                <Link 
                  to="/contact"
                  className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-violet-500 to-purple-500 text-white text-sm sm:text-base rounded-xl hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Get Started Today
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
